import { render, staticRenderFns } from "./CustomOrderDetails.vue?vue&type=template&id=65134340&scoped=true"
import script from "./CustomOrderDetails.vue?vue&type=script&lang=ts"
export * from "./CustomOrderDetails.vue?vue&type=script&lang=ts"
import style0 from "./CustomOrderDetails.vue?vue&type=style&index=0&id=65134340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65134340",
  null
  
)

export default component.exports